import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export const fetchProducts = async (category) => {
  const res = await api.get("/products", { params: category ? { category } : {} });
  return res.data;
};

export const submitContact = async (payload) => {
  const res = await api.post("/contact", payload);
  return res.data;
};
